import * as React from "react";
import { Input , Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Alert,  MenuItem, FormControl } from "@mui/material";
import cancelIcon from "../../app/assets/svgComponent/cancel.svg";
import saveIcon from "../../app/assets/svgComponent/save.svg";

const TableForm = ({
	item,
	departments,
	organizations,
	onChange,
	onSave,
	onClear,
	isEditing,
}) => {
	const [error, setError] = React.useState("");
	const [filteredDepartments, setFilteredDepartments] = React.useState([]);


	// Update filtered departments when props change
	React.useEffect(() => {
		console.log("Departments prop updated:", departments);
		if (Array.isArray(departments)) {
			setFilteredDepartments(departments);
		} else {
			setFilteredDepartments([]);
		}
	}, [departments]);

	// Log when departments update
	React.useEffect(() => {
		console.log("Updated departments:", filteredDepartments);
	}, [filteredDepartments]);


	const handleSave = () => {
		setError("");
		onSave();
	};

	const handleTextChange = (value, name) => {
		// value is the selected value from the Select component
		// name is the name of the field being changed
		if (name) {
			onChange({ target: { name, value } });
		} else {
			onChange(value); // For other inputs that may not have a name
		}
	};

	const isFormValid = () => {
		return item.name && item.description && item.head && item.department_id && item.organisation_id;
	};

	const inputStyle = {
		width: "368px",
		height: "34px",
		padding: "6px 10px",
		gap: "8px",
		borderRadius: "6px",
		border: "1px solid rgba(255, 255, 255, 1)",
		boxShadow: "0px 1px 2px 0px rgba(17, 24, 39, 0.08), 0px 0px 0px 1px rgba(17, 24, 39, 0.1)",
		backgroundColor: "#F3F4F6",
		fontSize: "14px"
	};

	const labelStyle = {
		display: "block",
		fontSize: "14px",
		color: "#374151",
		marginBottom: "8px",
		fontWeight: "500"
	};

	return (
		<div style={{ 
			width: "410px",
			height: "88vh",
			fontFamily: "inter",
			padding: "0",
			borderRadius: "12px",
			backgroundColor: "#FFFFFF",
			position: "fixed",
			right: "12px",
			top: "12px",
			boxShadow: `
				0px 20px 44px 0px rgba(0, 0, 0, 0.1),
				0px 80px 80px 0px rgba(0, 0, 0, 0.09),
				0px 180px 108px 0px rgba(0, 0, 0, 0.05),
				0px 319px 128px 0px rgba(0, 0, 0, 0.01),
				0px 499px 140px 0px rgba(0, 0, 0, 0)
			`,
			boxSizing: "border-box",
			display: "flex",
			flexDirection: "column",
			overflow: "hidden"
		}}>
			<div style={{
				width: "100%",
				height: "48px",
				padding: "8px 16px",
				borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				background: "rgba(247, 247, 248, 1)",
				flexShrink: 0
			}}>
				<div style={{ 
					display: "flex", 
					alignItems: "center", 
					gap: "6px"
				}}>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.00156 4.19961H2.10156V3.14961C2.10156 2.57001 2.57196 2.09961 3.15156 2.09961H5.22706C5.46086 2.09961 5.67996 2.21651 5.80946 2.41111L7.00156 4.19961Z" fill="#2563EB" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M2.10156 4.19971H10.8516C11.4312 4.19971 11.9016 4.67011 11.9016 5.24971V9.79971C11.9016 10.9589 10.9608 11.8997 9.80156 11.8997H4.20156C3.04236 11.8997 2.10156 10.9589 2.10156 9.79971V4.19971Z" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					<span style={{ 
						fontWeight: "500",
						fontSize: "16px"
					}}>
						{isEditing? "Edit Sub-Department":"Create New Sub-Department"}
					</span>
				</div>
			</div>

			<div style={{ 
				padding: "24px 12px 24px 24px", 
				width: "100%",
				flex: 1,
				overflowY: "auto",
				overflowX: "hidden"
			}}>
				{error && <Alert severity="error">{error}</Alert>}

				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Organization <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Select
							value={item.organisation_id || ""}
							onChange={(value) => handleTextChange(value, "organisation_id")}
							name="organisation_id"
							disabled={isEditing}
							displayEmpty
							style={{
								...inputStyle,
								width: "368px",
								height: "34px",
								backgroundColor: "#F3F4F6",
								'& .MuiSelect-select': {
									padding: "6px 10px",
									color: item.organisation_id ? 'black' : '#A9A9A9',
								},
							}}
							MenuProps={{
								PaperProps: {
									style: {
										maxHeight: 300,
										marginTop: 5,
										borderRadius: "6px",
										boxShadow: "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"
									}
								}
							}}
						>
							<MenuItem value="" disabled>
								<span style={{ color: '#A9A9A9', fontSize: '14px' }}>choose from this list</span>
							</MenuItem>
							{organizations.map((org) => (
								<MenuItem key={org.id} value={org.id}>{org.name}</MenuItem>
							))}
						</Select>
					</FormControl>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Department <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Select
							value={item.department_id || ""}
							onChange={(value) => handleTextChange(value, "department_id")}
							name="department_id"
							disabled={!item.organisation_id || isEditing}
							displayEmpty
							placeholder="Choose from this list"
							style={{
								...inputStyle,
								width: "368px",
								height: "34px",
							}}
						>
							<Select.Option value="" disabled>
								<span style={{ color: '#A9A9A9', fontSize: '14px' }}>choose from this list</span>
							</Select.Option>

							{Array.isArray(filteredDepartments) && filteredDepartments.length > 0 ? (
								filteredDepartments.map((dept) => (
									<Select.Option key={dept.id} value={dept.id}>
										{dept.name}
									</Select.Option>
								))
							) : (
								<Select.Option value="" disabled>
									<span style={{ color: '#A9A9A9', fontSize: '14px' }}>No Departments available</span>

								</Select.Option>
							)}
						</Select>
					</FormControl>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Name <span style={{ color: 'red' }}>*</span></label>
					<Input
						placeholder="Sub-Department Name"
						name="name"
						value={item.name || ""}
						onChange={handleTextChange}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Head <span style={{ color: 'red' }}>*</span></label>
					<Input
						placeholder="Sub-Department Head"
						name="head"
						value={item.head || ""}
						onChange={handleTextChange}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Description <span style={{ color: 'red' }}>*</span></label>
					<Input.TextArea
						placeholder="write it here"
						name="description"
						value={item.description || ""}
						onChange={handleTextChange}
						style={{ ...inputStyle, height: "100px" }}
					/>
				</div>
			</div>

			<div style={{ 
				width: "100%", 
				height: "80px", 
				display: "flex",
				gap: "10px",
				padding: "16px",
				background: "rgba(247, 247, 248, 1)",
				borderTop: "1px solid rgba(0, 0, 0, 0.1)",
				flexShrink: 0,
				justifyContent: "center",
				alignItems: "center",
				borderRadius: " 12px 12px 0 0"
			}}>
				<img 
					src={cancelIcon} 
					onClick={onClear}
					alt="cancel" 
					style={{ 
						width: "180px",
						height: "50px",
						objectFit: "contain",
						cursor: "pointer",
						transition: "transform 0.2s"
					}}
					onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
					onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
					onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
				/>
				
				<img 
					src={saveIcon} 
					onClick={isFormValid() ? handleSave : undefined}
					alt="save" 
					style={{ 
						width: "180px",
						height: "48px",
						objectFit: "contain",
						cursor: isFormValid() ? "pointer" : "not-allowed",
						transition: "transform 0.2s",
						opacity: isFormValid() ? 1 : 0.5
					}}
					onMouseDown={(e) => isFormValid() && (e.currentTarget.style.transform = "scale(0.95)")}
					onMouseUp={(e) => isFormValid() && (e.currentTarget.style.transform = "scale(1)")}
					onMouseLeave={(e) => isFormValid() && (e.currentTarget.style.transform = "scale(1)")}
				/>
			</div>
		</div>
	);
};

export default TableForm;
